// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
// Project Imports
import routeName from 'core/common/routeName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const BulkRule = lazy(() => import('pages/bulkRule/bulkRuleDownload'));

const BulkRuleDownload = (
  <Route path={routeName.bulkRuleDownload}>
    <Route
      index
      element={
        // <PrivateRoute name={PrivateRouteConst.BULK_RULE_DOWNLOAD}></PrivateRoute>
        <PrivateRoute name={PrivateRouteConst.RULE_BULK_DOWNLOAD}>
          <Suspense fallback={<Loading />}>
            <BulkRule />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default BulkRuleDownload;
